import { useRef } from 'react';

import { AreaChart, type AreaData, plotColors } from '../../../index';
import { ReplotChartNames } from '../../constants';
import { type CommonPlotProps, FormatType } from '../../types';
import { plotTestId } from '../../utilities/plotTestId';
import styles from './kde-chart.module.css';

type KdeValue = {
  value: number;
  kde: number;
  cdf: number;
};

export type KdeData = {
  label: string;
  color?: string;
  values: KdeValue[];
};

type KdeChartProps = {
  data: KdeData[];
  colors?: string[];
} & CommonPlotProps;

/**
 * Kernel Density Estimate chart
 * @deprecated Use AreaChart instead
 */
export const KdeChart = ({
  data,
  colors = plotColors,
  format = FormatType.SI,
  loading = false,
  renderUpdate,
  currencyCode,
}: KdeChartProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const areaData: AreaData[] = data.map((d) => ({
    label: d.label,
    values: d.values.map((v) => ({
      x: v.value,
      value: v.kde,
      secondaryValue: v.cdf,
    })),
  }));

  const colorArr = data.map((d, i) => d.color || colors[i % colors.length]);

  return (
    <div
      ref={containerRef}
      className={styles.container}
      data-testid={plotTestId(ReplotChartNames.KDE)}
    >
      <AreaChart
        data={areaData}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore noUncheckedIndexedAccess
        colors={colorArr}
        format={format}
        loading={loading}
        renderUpdate={renderUpdate}
        currencyCode={currencyCode}
        showYAxis={false}
      />
    </div>
  );
};
